import type { EmptyPrefetchProps } from '#src/shared/prefetch';
import { withPrefetchedData } from '#src/shared/prefetch';

import { Layout } from '../layout';

export const RacialJusticeFund = withPrefetchedData(
	function RacialJusticeFund(_props: EmptyPrefetchProps) {
		return <Layout />;
	},
	{
		prefetchName: __MODULE_HASH__,
		pageTitle: ({ fromTemplate }) => fromTemplate('Change.org Racial Justice Fund'),
		pageMetadata: () => ({
			description: 'Change.org Racial Justice Fund',
			ogTitle: 'Change.org Racial Justice Fund',
			ogDescription: 'Change.org Racial Justice Fund',
		}),
	},
);
